import { apiFetch } from "./apiFetch";

export function reportContent(payload) {
  return apiFetch("/reports/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function blockUser(userId) {
  return apiFetch(`/users/${userId}/block/`, { method: "POST" });
}

export function unblockUser(userId) {
  return apiFetch(`/users/${userId}/block/`, { method: "DELETE" });
}
